import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input } from '@components/index';
import { useAuthForm } from '../hooks/useAuthForm';
import { getErrorSelector, getPendingSelector } from '@modules/auth';
import { authResetLoginLinkRequest } from '../core/actions';
import { KTSVG, toAbsoluteUrl } from '@helpers/index';
import { FormattedMessage, useIntl } from 'react-intl';

export const LoginForm = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const {
    form,

    onSubmit,

    emailController,

    isLoginLinkRequested,
    setIsLoginLinkRequested,
  } = useAuthForm();

  const isPendingAuth = useSelector(getPendingSelector);

  const loginError = useSelector(getErrorSelector);

  const isSubscriptionNotFound =
    (loginError as (typeof loginError & { code?: string }) | null)?.code ===
    'SUBSCRIPTION_NOT_FOUND';

  useEffect(() => {
    return () => {
      if (isLoginLinkRequested) dispatch(authResetLoginLinkRequest());
    };
  }, [dispatch, isLoginLinkRequested]);

  useEffect(() => {
    return () => {
      setIsLoginLinkRequested(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form form={form} handleSubmit={onSubmit} className="login-form-wrapper">
      <div className="flex flex-col">
        <div className="input-wrapper">
          <Input
            label={intl.formatMessage({ id: 'FORM.EMAIL' })}
            placeholder={intl.formatMessage({ id: 'FORM.EMAIL' })}
            tabIndex={1}
            {...emailController.field}
            validationOptions={{
              required: intl.formatMessage({ id: 'FORM.EMAIL.REQUIRED' }),
            }}
          />
        </div>

        {(isLoginLinkRequested || loginError) && !isPendingAuth ? (
          <div className="text-center" role="alert">
            {loginError ? (
              isSubscriptionNotFound ? (
                <div className="login-warning" role="alert">
                  <KTSVG
                    path={toAbsoluteUrl('/media/svg/general/orange-info-icon.svg')}
                    className="login-warning__icon"
                  />
                  <p className="login-warning__text">
                    <FormattedMessage id="AUTH.LOGIN.NO_ACCOUNT_WARNING" />
                  </p>
                </div>
              ) : (
                <p className="login-msg login-msg-error">
                  <FormattedMessage id="AUTH.LOGIN.FAILED" />
                </p>
              )
            ) : (
              <div className="login-msg-wrapper">
                <div>
                  <KTSVG path={toAbsoluteUrl('/media/svg/general/checkmark.svg')} />
                </div>
                <p className="login-msg login-msg-success">
                  <FormattedMessage id="AUTH.LOGIN.EMAIL_SENT" />
                </p>
              </div>
            )}
          </div>
        ) : null}

        <Button variant="primary" type="submit" loading={isPendingAuth}>
          <FormattedMessage id="AUTH.LOGIN.SEND_LINK" />
        </Button>
      </div>
    </Form>
  );
};
